import { PageHeader } from "@/components/ui/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useNavigate } from "@tanstack/react-router";
import { ViewType, viewTypes } from "../types/subscriptionNavigation.type";
import { StandingOffers } from "./StandingOffers/StandingOffers";
import { SubscriptionOffers } from "./SubscriptionOffers/SubscriptionOffers";
import { Subscriptions } from "./Subscriptions/Subscriptions";

interface Props {
  view?: string;
  defaultSubscriptionsTab?: string;
}

const SubscriptionsPage = ({
  view = "subscriptions",
  defaultSubscriptionsTab
}: Props) => {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <PageHeader header="Your Organization's Subscriptions" />
      <Tabs
        value={view}
        onValueChange={(val) =>
          navigate({
            from: "/organization/$organizationSlug/subscriptions",
            search: {
              view: val === "subscriptions" ? undefined : (val as ViewType)
            },
            replace: true
          })
        }
      >
        <TabsList>
          <TabsTrigger value="subscriptions">Subscriptions</TabsTrigger>
          <TabsTrigger value={viewTypes[0]}>Subscription Offers</TabsTrigger>
          <TabsTrigger value={viewTypes[1]}>Standing Offers</TabsTrigger>
        </TabsList>
        <TabsContent value="subscriptions">
          <Subscriptions defaultTab={defaultSubscriptionsTab} />
        </TabsContent>
        <TabsContent value={viewTypes[0]}>
          <SubscriptionOffers />
        </TabsContent>
        <TabsContent value={viewTypes[1]}>
          <StandingOffers />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SubscriptionsPage;
